import { MDText } from 'i18n-react';

import { ClockIcon, EnvelopeIcon, IconComponentProps, IconText, PhoneIcon } from '@motorway/mw-highway-code';
import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { POST_SALE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsPostSale';
import { useUrlSlug } from 'Utilities/hooks/useUrlSlug';
import { FINANCE_PAYMENT_DETAILS_ROUTE, FINANCE_PAYMENT_DETAILS_ROUTE_MORE_FUNDS_REQUESTED } from 'Utilities/routing';

import { Modal } from 'Storybook/components/local/Modal/Modal';

import { useVehicleCollectionSub } from '../../hooks/useVehicleCollectionSub';
import { vehicleCollectionStore } from '../../VehicleCollectionSubjects';

import Texts from './SaleSupportModal.json';

import styles from './SaleSupportModal.scss';

const LocalT = new MDText(Texts);

const PAYMENT_TEAM_SUPPORT = new Set<string>([
  FINANCE_PAYMENT_DETAILS_ROUTE.substring(1),
  FINANCE_PAYMENT_DETAILS_ROUTE_MORE_FUNDS_REQUESTED.substring(1),
]);

export const SaleSupportModal = () => {
  const { isSaleSupportModalOpen } = useVehicleCollectionSub();
  const pathSegment = useUrlSlug();

  const shouldUsePaymentTeamHelp = PAYMENT_TEAM_SUPPORT.has(pathSegment);

  const translateKey = shouldUsePaymentTeamHelp ? 'specialist.payments' : 'regular';

  const supportEmail = LocalT.translate(`${translateKey}.supportEmail`);
  const supportPhoneNumber = LocalT.translate(`${translateKey}.supportPhoneNumber`);
  const openingHours = LocalT.translate(`${translateKey}.openingHours`);

  const closeModal = () => {
    vehicleCollectionStore.setIsSaleSupportModalOpen(false);
  };

  return isSaleSupportModalOpen ? (
    <Modal
      centered
      className={styles.container}
      contentClass={styles.modalContent}
      dialogClass={styles.modal}
      dismissModal={closeModal}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      size="small"
      withCloseButton={true}>
      <h3 className={styles.heading}>{LocalT.translate('label.heading')}</h3>
      <ul className={styles.details}>
        {supportPhoneNumber && <li>
          <IconText
            icon={PhoneIcon}
            text={<Hyperlink
              href={`tel:${supportPhoneNumber.toString().replace(/\s+/g, '')}`}
              label={supportPhoneNumber}
              onClick={() => POST_SALE_SNOW_PLOW_EVENTS.SALE_SUPPORT_MODAL_PHONE_NUMBER_CLICKED()}
              variant="primary"
            />}
            variant="small--regular" />
        </li>}
        {supportEmail && <li>
          <IconText
            icon={EnvelopeIcon}
            text={<Hyperlink
              href={`mailto:${supportEmail}`}
              label={supportEmail}
              onClick={() => POST_SALE_SNOW_PLOW_EVENTS.SALE_SUPPORT_MODAL_EMAIL_CLICKED()}
              variant="primary"
            />}
            variant="small--regular" />
        </li>}
        <li>
          <IconText
            icon={(props: IconComponentProps) => <ClockIcon {...props} filled={false} />}
            text={(
              <div className={styles.openingHours}>
                <h5>{LocalT.translate('label.openingHours')}</h5>
                <span className={styles.hours}>{openingHours}</span>
              </div>
            )}
            variant="small--regular" />
        </li>
      </ul>
    </Modal>
  ) : null;
};
